(() => {
  const translations = window.PKM_CUSTOMILY_I18N;

  if (!translations || !document.documentElement.classList.contains('pkm-customily-product')) return;

  const normalized = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const optionNames = new Map([
    ['Skriv din tekst her', translations.writeText],
    ['Vælg skrifttype', translations.chooseFont],
    ['Icon', translations.icon],
    ['Indgravering på', translations.engravingSide],
  ]);
  const visibleValues = new Map([
    ['Forsiden', translations.front],
    ['Bagsiden', translations.back],
    ['Gravering på begge sider – se her', translations.bothSides],
  ]);

  function replaceLeadingText(element, replacements) {
    if (!element) return;

    const textNode = [...element.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && normalized(node.nodeValue),
    );
    if (!textNode) return;

    const replacement = replacements.get(normalized(textNode.nodeValue));
    if (!replacement || normalized(textNode.nodeValue) === replacement) return;

    textNode.nodeValue = `\n                ${replacement}\n                `;
  }

  function localizeCustomily() {
    const previewButton = document.querySelector('#customily-preview-button.customily-preview-button');
    if (previewButton && normalized(previewButton.textContent) !== translations.previewButton) {
      previewButton.textContent = translations.previewButton;
      previewButton.setAttribute('aria-label', translations.previewButton);
    }

    document.querySelectorAll('#customily-options .customily_option .option_name > div').forEach((element) => {
      replaceLeadingText(element, optionNames);
    });

    document.querySelectorAll('#customily-options .label-text, #customily-options a').forEach((element) => {
      const replacement = visibleValues.get(normalized(element.textContent));
      if (replacement && normalized(element.textContent) !== replacement) element.textContent = replacement;
    });
  }

  let scheduled = false;
  const scheduleLocalization = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      localizeCustomily();
    });
  };

  localizeCustomily();
  new MutationObserver(scheduleLocalization).observe(document.body, { childList: true, subtree: true });
})();
